/**
 * Run non-critical work after the browser is idle (or after `timeout` ms).
 * Keeps long tasks off the critical path during first paint / Lighthouse.
 */
export function scheduleIdleWork(fn, { timeout = 4000 } = {}) {
    if (typeof window === 'undefined') {
        fn();
        return;
    }

    const run = () => {
        try {
            fn();
        } catch (err) {
            if (typeof console !== 'undefined' && console.error) {
                console.error('[scheduleIdleWork]', err);
            }
        }
    };

    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout });
        return;
    }

    setTimeout(run, 1);
}
